import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PanelStateless from './PanelStateless';
var PanelState = function PanelState(_ref) {
  var _ref$isDefaultExpande = _ref.isDefaultExpanded,
    isDefaultExpanded = _ref$isDefaultExpande === void 0 ? false : _ref$isDefaultExpande,
    children = _ref.children,
    header = _ref.header;
  var _useState = useState(isDefaultExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setisExpanded = _useState2[1];
  var handleChange = function handleChange() {
    setisExpanded(!isExpanded);
  };
  return /*#__PURE__*/React.createElement(PanelStateless, {
    header: header,
    isExpanded: isExpanded,
    onChange: handleChange
  }, children);
};
export default PanelState;